<template>
  <div class="details">
    <div class="error-box" v-show="!!errorReturn">{{ errorReturn }}</div>

    <div class="row">
      <div class="data-field">
        <div class="label">Name</div>
        <input type="text" :class="{'input':true, 'has-error':!!errorMsg.promoName}"
        v-model="promoName" :disabled="loading" />
        <span class="error-msg">{{ errorMsg.promoName }}</span>
      </div>
    </div>

    <div class="row">
      <div class="data-field">
        <div class="label">Description</div>
        <textarea v-model="description" class="input" :disabled="loading"></textarea>
      </div>
    </div>

    <div class="row">
      <div class="column small-12">
        <div class="data-field">
          <div class="label">Start Date</div>
          <div class="row">
            <div class="column small-5 padding-R">
              <datepicker :format="calendarFormat" class="datepicker inline"
                v-model="startDate" :disabled-picker="loading" :disabled="startDateDisabled"
                :input-class="{'datepicker-empty':errorMsg.startDate}"
              ></datepicker>
              <span class="error-msg">{{ errorMsg.startDate || errorMsg.startDateHour || errorMsg.startDateMinute }}</span>
            </div>
            <div class="column small-3 padding-L">
              <select v-model="startDateHour" :class="{'has-error':!!errorMsg.startDateHour}" :disabled="loading">
                <option value="" disabled selected>Hour</option>
                <option v-for="x in 24" :value="leadingZero(x - 1)">{{ leadingZero(x - 1) }}</option>
              </select>
            </div>
            <div class="column small-1 text-center"><span class="time">:</span></div>
            <div class="column small-3">
              <select v-model="startDateMinute" :class="{'has-error':!!errorMsg.startDateMinute}" :disabled="loading">
                <option value="" disabled selected>Minute</option>
                <option v-for="x in 12" :value="leadingZero((x - 1) * 5)">{{ leadingZero((x - 1) * 5) }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="column small-12">
        <div class="data-field">
          <div class="label">Expiration Date</div>
          <div class="row">
            <div class="column small-5 padding-R">
              <datepicker :format="calendarFormat" class="datepicker inline"
              v-model="expirationDate" :disabled-picker="loading" :disabled="expirationDateDisabled"
              :input-class="{'datepicker-empty':errorMsg.expirationDate}"
              ></datepicker>
              <span class="error-msg">{{ errorMsg.expirationDate || errorMsg.expirationDateHour || errorMsg.expirationDateMinute }}</span>
            </div>
            <div class="column small-3 padding-L">
              <select v-model="expirationDateHour" :class="{'has-error':!!errorMsg.expirationDateHour}" :disabled="loading">
                <option value="" disabled selected>Hour</option>
                <option v-for="x in 24" :value="leadingZero(x - 1)">{{ leadingZero(x - 1) }}</option>
              </select>
            </div>
            <div class="column small-1 text-center"><span class="time">:</span></div>
            <div class="column small-3">
              <select v-model="expirationDateMinute" :class="{'has-error':!!errorMsg.expirationDateMinute}" :disabled="loading">
                <option value="" disabled selected>Minute</option>
                <option v-for="x in 12" :value="leadingZero((x - 1) * 5)">{{ leadingZero((x - 1) * 5) }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="column small-6 padding-R">
        <div class="data-field">
          <div class="label">Days Valid after Redemption</div>
          <input type="text" :class="{'input':true, 'has-error':!!errorMsg.validDays}" v-model="validDays" :disabled="loading" />
          <span class="error-msg">{{ errorMsg.validDays }}</span>
        </div>
      </div>
      <div class="column small-6 padding-L">
        <div class="data-field">
          <div class="label">Valid Only for New Users</div>
          <select v-model="validNewUser" :disabled="loading">
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="column small-4 padding-R">
        <div class="data-field">
          <div class="label">Promo Code</div>
          <input type="text" :class="{'input':true, 'has-error':!!errorMsg.code}" v-model="code" :disabled="loading"/>
          <span class="error-msg">{{ errorMsg.code }}</span>
        </div>
      </div>
      <div class="column small-4 padding-R padding-L">
        <div class="data-field">
          <div class="label">Credit Amount</div>
          <input type="text" :class="{'input':true, 'has-error':!!errorMsg.amount}" v-model="amount" :disabled="loading"/>
          <span class="error-msg">{{ errorMsg.amount }}</span>
        </div>
      </div>

      <div class="column small-4 padding-L">
        <div class="data-field">
          <div class="label">Number of Codes to Redeem</div>
          <input type="text" :class="{'input':true, 'has-error':!!errorMsg.totalCodes}" v-model="totalCodes" :disabled="loading"/>
          <span class="error-msg">{{ errorMsg.totalCodes }}</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment-timezone'
import datepicker from 'vuejs-datepicker'
import ApiPromo from '@/modules/api/promo'

export default {
  name: 'promo-view-edit',
  components: { datepicker },
  data () {
    return {
      promoName: '',
      description: '',
      startDate: '',
      startDateHour: '',
      startDateMinute: '',
      expirationDate: '',
      expirationDateHour: '',
      expirationDateMinute: '',
      validDays: '',
      validNewUser: '1',
      code: '',
      amount: '',
      totalCodes: '',
      errorMsg: {
        promoName: '',
        startDate: '',
        startDateHour: '',
        startDateMinute: '',
        expirationDate: '',
        expirationDateHour: '',
        expirationDateMinute: '',
        validDays: '',
        code: '',
        amount: '',
        totalCodes: ''
      },
      today: moment().subtract(1, 'days'),
      errorReturn: ''
    }
  },
  computed: {
    _promo () { return this.$store.state.promo.view.details },
    startDateDisabled () {
      if (this.today.format('MM') === '01') {
        return {
          to: new Date(
            this.today.subtract(1, 'months').format('YYYY'),
            this.today.format('MM'),
            this.today.format('DD')
          )
        }
      }

      return {
        to: new Date(
          this.today.format('YYYY'),
          this.today.subtract(1, 'months').format('MM'),
          this.today.format('DD')
        )
      }
    },
    expirationDateDisabled () {
      let date = this.startDate ? moment(this.startDate).add(1, 'days') : moment()
      if (date.format('MM') === '01') {
        return {
          to: new Date(
            date.subtract(1, 'months').format('YYYY'),
            date.format('MM'),
            date.format('DD')
          )
        }
      }

      return {
        to: new Date(
          date.format('YYYY'),
          date.subtract(1, 'months').format('MM'),
          date.format('DD')
        )
      }
    },
    loading () { return this.$store.state.promo.view.saving }
  },
  methods: {
    calendarFormat (date) { return moment(date).format('MM/DD/YYYY') },
    save () {
      let self = this
      if (self.loading) { return }

      if (self.validate()) {
        self.$store.commit('promo/setViewSaving', true)
        let startDate = moment(self.startDate)
        startDate = moment(startDate.format('MM/DD/YYYY ') + self.startDateHour + ':' + self.startDateMinute)
        let expirationDate = moment(self.expirationDate)
        expirationDate = moment(expirationDate.format('MM/DD/YYYY ') + self.expirationDateHour + ':' + self.expirationDateMinute)

        ApiPromo.savePromoDetails(self, {
          id: self.$store.state.promo.view.details.id,
          name: self.promoName,
          description: self.description,
          startDate: startDate.format('YYYY-MM-DD HH:mm:ss'),
          expirationDate: expirationDate.format('YYYY-MM-DD HH:mm:ss'),
          validDays: self.validDays,
          validOnlyForNewUser: self.validNewUser === '1',
          promoCode: self.code,
          amount: self.amount,
          totalCodes: self.totalCodes
        }, function (res) {
          self.$store.commit('promo/setViewSaving', true)
          if (res.error) {
            self.errorReturn = res.error.message
            return
          }

          location.reload()
        })
      }
    },
    validate () {
      this.resetErrorMsg()
      let hasError = false

      for (let field in this.errorMsg) {
        if (this[field] === '') {
          this.errorMsg[field] = 'This field cannot be empty.'
          hasError = true

        }
        if (field === 'totalCodes' && parseInt(this[field]) < this._promo.totalCodes) {
          this.errorMsg[field] = 'The number of codes to redeem cannot be lower than the currently existing number of codes.'
          hasError = true
        }
      }

      return !hasError
    },
    resetErrorMsg () {
      this.errorMsg = {
        promoName: '',
        startDate: '',
        startDateHour: '',
        startDateMinute: '',
        expirationDate: '',
        expirationDateHour: '',
        expirationDateMinute: '',
        validDays: '',
        code: '',
        amount: '',
        totalCodes: ''
      }
    },
    leadingZero (x) { return x < 10 ? '0' + x : x }
  },
  watch: {
    _promo: function (value) {
      this.promoName = value.name
      this.description = value.description || ''

      let startDate = moment(value.startDate, 'MM/DD/YYYY HH:mm')
      this.startDate = startDate.format('MM/DD/YYYY')
      this.startDateHour = startDate.format('HH')
      let startMinFix = parseInt(startDate.format('m')) % 5
      this.startDateMinute = startDate.subtract(startMinFix, 'minutes').format('mm')

      let expirationDate = moment(value.expirationDate, 'MM/DD/YYYY HH:mm')
      this.expirationDate = expirationDate.format('MM/DD/YYYY')
      this.expirationDateHour = expirationDate.format('HH')
      let expMinFix = parseInt(expirationDate.format('m')) % 5
      this.expirationDateMinute = expirationDate.subtract(expMinFix, 'minutes').format('mm')

      this.validDays = value.validDays
      this.validNewUser = value.validNewUser === 'Yes' ? '1' : '0'
      this.code = value.code
      this.amount = value.amount
      this.totalCodes = value.totalCodes
    },
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.details{
  margin: 20px 0 100px;
  padding: 0 30px;
}

.data-field{
  margin-bottom: 20px;
  .label{
    font-weight: 600;
    color: #5495c3;
    font-size: 11px;
    text-transform: uppercase;
    line-height: 120%;
  }
  .input{
    margin: 1px 0 0;
    color: #333;
    line-height: inherit;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
    &:disabled{ background: #eee; }
  }
  select{
    border: 1px solid #ddd;
    padding: 10px;
    color: #333;
    height: 45px;
    position: relative;
    font-size:14px;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url('/assets/img/dropdown-arrow.png');
    background-repeat: no-repeat;
    background-position: right 50%;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
    &:disabled{ background-color: #eee; }
  }
  .error-msg{
    font-size: 11px;
    line-height: 1.6;
    color: #f20d0d;
    font-style: italic;
    display: block;
  }
}

.datepicker{ margin-top: 1px; }
.time{
  display: inline-block;
  line-height: 45px;
}

.error-box{
  margin:0 30px;
  border:1px solid #f34c31;
  color:#f34c31;
  padding: 5px;
  margin-bottom: 15px;
  font-size:14px;
  font-weight:600;
}

.padding-L{ padding-left: 10px; }
.padding-R{ padding-right: 10px; }
.text-center{ text-align: center; }

@media only screen and (max-width: 430px) {
  .details {
    margin-top: 125px;
  }
  
  .small-4 {
    width: 100%;
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Promo/PromoViewEdit.vue